// Komunikat o zakończeniu wymiany pokazujemy od 06.09.2026 00:00
// (po północy z 05.09 na 06.09); ?komunikat=1 wymusza go wcześniej.
export function isExchangeEnded() {
  if (new URLSearchParams(window.location.search).get('komunikat') === '1') {
    return true
  }
  return new Date() >= new Date(2026, 8, 6)
}
